// ABOUTME: Closes an open overlay when Escape is pressed, for the hand-rolled modals that draw their
// ABOUTME: own backdrop instead of going through CPopup — which owns this behaviour itself.

import { useEffect } from "react"

/**
 * Calls `onClose` on Escape while `isActive`.
 *
 * A modal that draws its own `fixed inset-0` has no dismissal of its own: the backdrop click and the
 * close button are mouse-only. Three of them repeated the same effect verbatim, which is also what
 * jscpd flagged, so the effect lives here once.
 *
 * Pass `isActive: false` while the overlay is closed so a hidden modal listens to nothing. A modal
 * that is mounted only while open can leave it at the default.
 */
export const useCloseOnEscape = (onClose: () => void, isActive = true): void => {
  useEffect(() => {
    if (!isActive) return

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose()
    }

    document.addEventListener("keydown", handleEscape)
    return () => document.removeEventListener("keydown", handleEscape)
  }, [isActive, onClose])
}
